// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3X6LY","tabsBox":"styles_tabsBox__33pDv","createButton":"styles_createButton__3gV0A"};